import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Projects from './ProjectsList';
import Button from '@material-ui/core/Button';
import PersonIcon from '@material-ui/icons/Person';
import Resume from './Resume';
import HeaderImage from '../images/headerback.jpg';
import { Link } from "react-router-dom";
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import Me from '../images/me.jpg';

const styles = theme => ({

    root: {
    },

    header: {

        paddingTop: theme.spacing.unit * 3,
        paddingBottom: theme.spacing.unit * 3,

        [theme.breakpoints.up('sm')]: {

            paddingBottom: theme.spacing.unit * 4,
        },

        backgroundColor: theme.palette.custom.headerBack,
        boxShadow: "inset 0 0 20px rgba(0,0,0,.5)",
        backgroundImage: "url(" + HeaderImage +")",
        backgroundSize: 'cover'
    },

    body: {

        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        
    },

    white: {
        color: 'white',
        textAlign: 'center'
    },

    button: {
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,

    },

    avatar: {

        width: '200px',
        height: '200px', 
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '80px',
            height: '80px', 
        },
        [theme.breakpoints.between('sm', 'md')]: {
            width: '100px',
            height: '100px', 
        },
        [theme.breakpoints.between('md', 'xl')]: {
            width: '150px',
            height: '150px', 
        },
        marginRight: theme.spacing.unit * 1

    },

    headerButtons: {

    },

    avatarImage: {
        height: 'inherit',
        width: 'inherit'
    },
    githubIcon: {

        width: '24px',
        marginRight: theme.spacing.unit,

    },
    rightIcon: {
        marginLeft: theme.spacing.unit
    },
    customButton: {
        color: 'white',
        backgroundColor: theme.palette.custom.main,
        '&:hover': {
          backgroundColor: theme.palette.custom.dark,
        },
        padding: theme.spacing.unit
    },
    spacing: {
        margin: theme.spacing.unit
    },
    close: {
        padding: theme.spacing.unit / 2,
      },
      bigAvatar: {
        margin: 10,

        width: '7rem',
        height: '7rem',

        [theme.breakpoints.down("sm")]: {
            width: '6rem',
            height: '6rem',
        },
        [theme.breakpoints.down("xs")]: {
            width: '4rem',
            height: '4rem',
        },
    
      },

});

class Home extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    render() {
        const { classes } = this.props;

        return (

            <div className={classes.root}>

                <Grid container direction="column" justify="center" alignItems="center" className={classes.header} >
                
                    <Grid item>

                        <Grid container direction="row" justify="center" alignItems="center" className={classes.spacing}>

                            <Avatar src={Me} className={classes.bigAvatar} />
                            <Typography variant="h1" className={classes.white}>
                                
                                Hello, I'm Jordan
                            </Typography> 
                           
                        </Grid>
                        <Grid container direction="column" justify="center" alignItems="center" spacing={32}>
                            <Grid item>
                                <Typography variant="body1" className={classes.white} >
                                    A software developer / student based in Phoenix, Arizona
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="center" alignItems="center" className={classes.headerButtons} spacing={8}>
                                    <Grid item>
                                        <Button component={Link} to="/about" variant="contained" color="primary" className={classes.button} size="large" >
                                            About me
                                            <PersonIcon className={classes.rightIcon} />
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Resume/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container direction="column" justify="center" alignItems="center" spacing={32} className={classes.body} >
                    <Grid item>
                        <Typography variant="h2" className={classes.title} align="center">
                            My Projects
                        </Typography>

                    </Grid>
                    <Grid item>
                        <Divider className={classes.spacing}/>
                        <Projects projects={this.props.projects} />
                    </Grid>

                </Grid>

            </div>
        );
    }
}

export default withStyles(styles)(Home);